// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconLineArrowTransferHorizontal1 = createRemixIcon('IconLineArrowTransferHorizontal1', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20.984 10.25H24l-2.134-2.134l-7-7L13.1 2.884l4.866 4.866H0v2.5zm3.017 6H6.037l4.866 4.866l-1.768 1.768l-7-7L0 13.75h24z\" clip-rule=\"evenodd\"/>");
